var exports = {
  "P": "ProfileCardLayout.module__previewLabel___VTFRak",
  "K": "ProfileCardLayout.module__profileCard___VTFRak",
};

module.exports = exports;
